<template>
  <div ref="containerRef" class="timeline-container">

    <img src="@/assets/flor1.png" class="flor flor-left" alt="flor izquierda" />
    <img src="@/assets/flor1.png" class="flor flor-right" alt="flor derecha" />

    <div class="carousel-wrapper">
      
      <button
        class="carousel-button left"
        @click="prevSlide"
        v-if="currentIndex > 0"
        aria-label="Anterior"
      >‹</button>
      <button
        class="carousel-button right"
        @click="nextSlide"
        v-if="currentIndex < processedHotels.length - 1"
        aria-label="Siguiente"
      >›</button>

      <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div
          v-for="(hotel, index) in processedHotels"
          :key="index"
          class="hotel-card"
          :ref="el => setHotelCard(el, index)"
        >
          <p class="recomendacion-hospedaje" :ref="el => setRefs(el, index, 'titulo')">{{ hotel.titulo }}</p>
          <p :ref="el => setRefs(el, index, 'descripcion')">{{ hotel.descripcion }}</p>
          <img
            :src="hotel.imagen"
            :alt="hotel.nombre"
            class="hotel-image rounded-circle"
            :ref="el => setRefs(el, index, 'imagen')"
          />
          <div class="hotel-info" :ref="el => setRefs(el, index, 'info')">
            <h3>{{ hotel.nombre }}</h3>
            <strong>Dirección:</strong><br />
            <p>{{ hotel.direccion }}</p>
            <p><i class="fas fa-phone" /> {{ hotel.telefono }}</p>
            
            <p v-if="hotel.notaEspecial" class="hotel-nota-especial" v-html="hotel.notaEspecial"></p>

            <a
              :href="hotel.ubicacion"
              class="modern-button"
              target="_blank"
              rel="noopener noreferrer"
              :ref="el => setRefs(el, index, 'boton')"
            >
              Ubicación <i class="fas fa-map-marker-alt" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, computed } from 'vue';
import { gsap } from 'gsap';

import hotel1Img from '@/assets/h1.webp';
import hotel2Img from '@/assets/h2.webp';
import hotel3Img from '@/assets/h3.webp';

export default {
  name: 'HospedajeVue',
  setup() {
    const containerRef = ref(null);
    const hotelCards = ref([]);
    const refsMap = ref([]);
    const currentIndex = ref(0);

    const hotels = [
      {
        id: 'holiday-inn',
        titulo: 'Hospedaje.',
        descripcion: 'Recomendación',
        nombre: 'Holiday Inn Express & Suites Tampa',
        imagen: hotel2Img,
        direccion: '9402 Corporate Lake Dr, Tampa, Florida',
        telefono: '+1 813 885 37 00',
        ubicacion: 'https://maps.app.goo.gl/JLCqMQw3HKW1Kstd7',
        notaEspecial: '<strong>Descuento Especial en el Hotel</strong><br /><br />Hemos reservado una tarifa especial para nuestros invitados. Para recibir el descuento, menciona que asistirás a la Quinceañera al hacer tu reservación. ¡Nos encantaría que te quedaras a celebrar con nosotros!'      
      },
      {
        id: 'hilton',
        titulo: 'Hospedaje.',
        descripcion: 'Otra buena opción.',
        nombre: 'Hilton Garden Inn Tampa Airport Westshore',
        imagen: hotel3Img,
        direccion: '5312 Avion Park Dr, Tampa, Florida',
        telefono: '+1 81 328 927 00',
        ubicacion: 'https://maps.app.goo.gl/woYYN5VCQUFYsqbj8'
      },
      {
        id: 'hampton',
        titulo: 'Hospedaje.',
        descripcion: 'Otra buena opción..',
        nombre: 'Hampton Inn Odessa Trinity',
        imagen: hotel1Img,
        direccion: '11780 FL-54, Odessa, Florida',
        telefono: '+1 813 749 68 26 ',
        ubicacion: 'https://maps.app.goo.gl/Qe5QBZcYL6drJys86'
      }
    ];

    const processedHotels = computed(() => hotels);

    const setHotelCard = (el, index) => {
      if (el) hotelCards.value[index] = el;
    };

    const setRefs = (el, index, key) => {
      if (!refsMap.value[index]) refsMap.value[index] = {};
      refsMap.value[index][key] = el;
    };

    const animateElements = (elements) => {
      if (!elements) return;
      gsap.fromTo(elements.titulo, { x: -50, opacity: 0 }, { x: 0, opacity: 1, duration: 0.6 });
      gsap.fromTo(elements.descripcion, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 0.6, delay: 0.2 });
      gsap.fromTo(elements.imagen, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, delay: 0.4 });
      gsap.fromTo(elements.info, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6, delay: 0.6 });
      gsap.fromTo(elements.boton, { scale: 0.8, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.6, delay: 0.8 });
    };

    const prevSlide = () => {
      if (currentIndex.value > 0) {
        currentIndex.value--;
        nextTick(() => animateElements(refsMap.value[currentIndex.value]));
      }
    };

    const nextSlide = () => {
      if (currentIndex.value < processedHotels.value.length - 1) {
        currentIndex.value++;
        nextTick(() => animateElements(refsMap.value[currentIndex.value]));
      }
    };

    onMounted(() => {
      const florLeft = document.querySelector('.flor-left');
      const florRight = document.querySelector('.flor-right');

      gsap.fromTo([florLeft, florRight], 
        { autoAlpha: 0, scale: 0.85, y: 20 },
        { autoAlpha: 1, scale: 1, y: 0, duration: 1.2, ease: 'power3.out', delay: 0.1 }
      );

      gsap.to(florLeft, { y: '-=10', duration: 3, yoyo: true, repeat: -1, ease: 'sine.inOut' });
      gsap.to(florRight, { y: '+=10', duration: 3.2, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 0.2 });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = hotelCards.value.findIndex(el => el === entry.target);
            if (index !== -1) {
              animateElements(refsMap.value[index]);
              observer.unobserve(entry.target);
            }
          }
        });
      }, { threshold: 0.3 });

      hotelCards.value.forEach(card => card && observer.observe(card));
    });

    return { 
      containerRef, 
      hotelCards, 
      processedHotels, 
      currentIndex, 
      prevSlide, 
      nextSlide, 
      setHotelCard, 
      setRefs 
    };
  }
};
</script>

<style scoped>
.timeline-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 95vh; 
  background: #f0c9d3; /* Tu color rosa original */
  position: relative;
  overflow: visible;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.flor {
  position: absolute;
  width: min(42vw, 240px);
  z-index: 5;
  filter: drop-shadow(0px 4px 10px rgba(0,0,0,0.15));
  pointer-events: none;
  opacity: 0;
  transform-origin: center;
}

.flor-left {
  left: -90px;
  top: 120px;
  transform: rotate(-12deg);
}

.flor-right {
  right: -90px;
  bottom: 120px;
  transform: rotate(20deg);
}

.carousel-wrapper {
  position: relative;
  width: 80%;
  overflow: hidden;
}

.carousel {
  display: flex;
  transition: transform 0.6s ease;
}

.hotel-card {
  width: 100%;
  max-width: 500px;
  flex-shrink: 0;
  text-align: center;
  padding: 60px 24px; 
  margin: 0 auto;
  border-radius: 0 80px 0 80px;
  background-color: #eaadc0;
  transition: transform 0.3s ease;
  box-shadow: 0 8px 20px rgba(0,0,0,0.16);
}

.hotel-card:hover {
  transform: scale(1.03);
}

.hotel-image {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 18px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .18);
}

.hotel-info {
  font-family: 'Josefin Sans', sans-serif;
  color: rgba(23, 24, 23, 0.9);
  line-height: 1.4;
}

.hotel-info h3 {
  font-size: 19px;
  color: #202020;
  font-weight: bold;
  margin-bottom: 8px;
}

.hotel-card p {
  font-size: 15px;
  color: #201e1e;
}

.hotel-nota-especial {
  background-color: rgba(255, 255, 255, 0.4);
  border-left: 3px solid #ffffff;
  padding: 10px 14px;
  margin: 15px auto;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 1.4;
  color: #1e1d1d !important;
  border-radius: 4px;
  max-width: 90%;
  text-align: left;
}

.recomendacion-hospedaje {
  font-family: 'verde';
  font-size: 44px !important;
  margin-bottom: 12px;
  color: #181918d7 !important;
}

.modern-button {
  display: inline-block;
  text-decoration: none;
  background: #ffffff;
  color: #333;
  padding: 8px 20px;
  font-family: 'padres';
  font-weight: bold;
  border: none;
  border-radius: 25px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, background 0.3s ease;
  margin-top: 5px;
  margin-bottom: 5px;
}

.modern-button:hover {
  background: #f7f7f7;
  transform: translateY(-2px);
}

.carousel-button {
  position: absolute;
  top: 50%;
  background: #f1efef;
  color: #333;
  width: 44px;
  height: 44px;
  font-size: 28px;
  font-family: 'Arial';
  font-weight: bold;
  z-index: 10;
  cursor: pointer;
  transform: translateY(-50%);
  transition: transform 0.3s ease, opacity 0.3s ease;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-button.left {
  left: 10px;
  animation: moveLeft 1s infinite ease-in-out;
}

.carousel-button.right {
  right: 10px;
  animation: moveRight 1s infinite ease-in-out;
}

.carousel-button:hover {
  transform: scale(1.2) translateY(-50%);
  opacity: 1;
}

@keyframes moveLeft {
  0%, 100% { transform: translateX(0) translateY(-50%); opacity: 1; }
  50% { transform: translateX(-6px) translateY(-50%); opacity: 0.7; }
}

@keyframes moveRight {
  0%, 100% { transform: translateX(0) translateY(-50%); opacity: 1; }
  50% { transform: translateX(6px) translateY(-50%); opacity: 0.7; }
}

@media (max-width: 768px) {
  .flor {
    width: min(50vw, 150px);
  }
  .flor-left {
    left: -60px;
    top: 60px;
  }
  .flor-right {
    right: -60px;
    bottom: 60px;
  }
  .hotel-card {
    padding: 45px 16px;
  }
}
</style>